import { memo } from 'react';

import { Box } from '@material-ui/core';

import { useStyles } from './style';

interface Props {
  title?: string | JSX.Element | JSX.Element[] | null;
  status?: string;
}

const CaseTitle: React.FC<Props> = ({ title, status }) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" marginBottom={2}>
      <h2 className={classes.title}>{title}</h2>
      <span className={classes.tag}>{status}</span>
    </Box>
  );
};

export default memo(CaseTitle);
